module.exports = __webpack_public_path__ + "img/jo1.10193f4c.png";